export default {"src":"/_next/static/media/neos.dd29418a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};